import { Navigate, useLocation } from 'react-router-dom';

const normalizeRoleName = (rawRole) => {
  const raw = (rawRole || '').trim();
  if (!raw) {
    return '';
  }
  const canonical = raw.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (canonical === 'SYSADMIN') {
    return 'SYS_ADMIN';
  }
  if (canonical === 'TENANTADMIN') {
    return 'TENANT_ADMIN';
  }
  if (canonical === 'TENANTUSER') {
    return 'TENANT_USER';
  }
  return raw.toUpperCase();
};

const resolveRoleFromStorage = () => {
  const storedRole = normalizeRoleName(sessionStorage.getItem('authRole'));
  if (storedRole) {
    return storedRole;
  }
  const token = sessionStorage.getItem('authToken');
  if (!token || !token.includes('.')) {
    return '';
  }
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return normalizeRoleName(decoded?.role);
  } catch (_error) {
    return '';
  }
};

function RequireRole({ children, allowedRoles }) {
  const location = useLocation();
  const currentRole = resolveRoleFromStorage();
  const canAccess = Array.isArray(allowedRoles) && allowedRoles.includes(currentRole);

  if (!canAccess) {
    return <Navigate to="/home" state={{ from: location.pathname }} replace />;
  }

  return children;
}

export default RequireRole;
